import { render, staticRenderFns } from "./PatientAgreement.vue?vue&type=template&id=0e4d3032&scoped=true&"
import script from "./PatientAgreement.vue?vue&type=script&lang=js&"
export * from "./PatientAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4d3032",
  null
  
)

export default component.exports